import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const nav = useNavigate();
  const { loginGoogleSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      nav("/login");
      return;
    }
    (async () => {
      try {
        await loginGoogleSession(sessionId);
        toast.success("Signed in via Google");
        // Clean hash
        window.history.replaceState(null, "", "/ecosystem");
        nav("/ecosystem", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [loginGoogleSession, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback-loader">
      <div className="font-mono text-neon-green animate-pulse">AUTHENTICATING…</div>
    </div>
  );
}
